document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-round-photo-editor]').forEach(editor => {
    const form = editor.closest('form');
    const input = form.querySelector('[data-artwork-upload]');
    const caption = form.querySelector('[data-personalization]');
    const year = form.querySelector('[data-round-year]') || form.querySelector('#OrnamentSecondary');
    const font = form.querySelector('[data-round-font]');
    const canvas = editor.querySelector('canvas');
    const context = canvas.getContext('2d');
    const output = editor.querySelector('[data-round-file]');
    const layout = editor.querySelector('[data-round-layout]');
    const controls = editor.querySelector('[data-round-controls]');
    const sizeNote = editor.querySelector('[data-round-size-note]');
    const quality = editor.querySelector('[data-round-quality]');
    const lowWrap = editor.querySelector('[data-round-low]');
    const lowCheck = lowWrap.querySelector('input');
    const error = editor.querySelector('[data-round-error]');
    const zoom = editor.querySelector('[data-round-zoom]');
    const x = editor.querySelector('[data-round-x]');
    const y = editor.querySelector('[data-round-y]');
    const rotation = editor.querySelector('[data-round-rotation]');
    const textSize = editor.querySelector('[data-round-text-size]');
    const textSizeValue = editor.querySelector('[data-round-text-size-value]');
    const textSizeProperty = editor.querySelector('[data-round-text-property]');
    const settings = JSON.parse(editor.querySelector('[data-round-settings]').textContent);
    const gallery = form.closest('[data-product-root]').querySelector('[data-product-gallery]');
    const galleryPreview = editor.querySelector('[data-round-gallery-preview]');
    const adjust = editor.querySelector('[data-round-adjust]');
    const reset = adjust.querySelector('[data-round-reset]');
    gallery.querySelector('[data-preview-stage]').append(galleryPreview);
    gallery.append(adjust);
    editor.querySelector('[data-round-view]').addEventListener('click', () => gallery.scrollIntoView({ behavior: 'smooth', block: 'start' }));
    let image = null;
    let photoUrl = null;
    let generation = 0;
    let fontReady = false;
    let busy = false;
    let submitting = false;
    let scale = 1;
    let revision = 0;
    const showError = message => { error.textContent = message; error.hidden = !message; };
    const selectedSize = () => {
      const product = JSON.parse(form.closest('[data-product-root]').querySelector('[data-product-json]').textContent);
      const variant = product.variants.find(item => String(item.id) === form.querySelector('[data-variant-id]').value);
      const sizeIndex = product.options.findIndex(option => /size/i.test(typeof option === 'string' ? option : option.name));
      if (sizeIndex < 0) return 3;
      const match = String(variant?.options?.[sizeIndex] || '').trim().match(/^(3(?:\.5)?)\s*(?:["″]|inch|inches)?$/i);
      return match ? Number(match[1]) : 0;
    };
    const eligible = () => selectedSize() > 0;
    const ribbonColor = () => {
      const product = JSON.parse(form.closest('[data-product-root]').querySelector('[data-product-json]').textContent);
      const variant = product.variants.find(item => String(item.id) === form.querySelector('[data-variant-id]').value);
      const colorIndex = product.options.findIndex(option => /ribbon|color/i.test(typeof option === 'string' ? option : option.name));
      const colorField = [...form.querySelectorAll('[data-option-position]')].find(field => /ribbon|color/i.test(field.dataset.optionName || ''));
      const chosen = String(colorField?.querySelector('input:checked')?.value || colorField?.querySelector('select')?.value || variant?.options?.[colorIndex] || 'Wood').trim();
      const palette = { White: ['#f7f4ed','#d5cdbd','#15232a'], Navy: ['#203b55','#12283c','#fffaf0'], Black: ['#202020','#080808','#fffaf0'], Gray: ['#747a7b','#4a5051','#fffaf0'], Wood: ['#b77d36','#a36c2d','#fffaf0'] };
      const paletteKey = Object.keys(palette).find(key => key.toLowerCase() === chosen.toLowerCase());
      return { name: paletteKey || chosen, colors: palette[paletteKey] || palette.Wood, custom: !paletteKey, selectable: Boolean(colorField) };
    };
    const team = form.querySelector('#OrnamentTeam');
    const sport = form.querySelector('#OrnamentSport');
    const active = () => Boolean(image && eligible() && !form.querySelector('[data-reuse-artwork]')?.checked);
    const clearOutput = () => { output.value = ''; output.disabled = true; };
    const fitText = (text, size, family, weight, width, baseline, maxAscent, maxDescent) => {
      context.font = `${weight} ${size}px "${family}"`;
      const safeWidth = () => {
        const metrics = context.measureText(text);
        const edge = Math.max(Math.abs(baseline + (metrics.actualBoundingBoxDescent || size * .25) - 450), Math.abs(baseline - (metrics.actualBoundingBoxAscent || size) - 450));
        return Math.min(width, 2 * Math.sqrt(Math.max(0, 438 * 438 - edge * edge)));
      };
      while (context.measureText(text).width > safeWidth() && size > 10) {
        size -= 1;
        context.font = `${weight} ${size}px "${family}"`;
      }
      const originalMetrics = context.measureText(text);
      const ascentLimit = Math.max(maxAscent, originalMetrics.actualBoundingBoxAscent || size);
      const descentLimit = Math.max(maxDescent, originalMetrics.actualBoundingBoxDescent || size * .25);
      size *= Number(textSize.value) / 100;
      context.font = `${weight} ${size}px "${family}"`;
      const fits = () => {
        const metrics = context.measureText(text);
        return metrics.width <= safeWidth() && (metrics.actualBoundingBoxAscent || size) <= ascentLimit && (metrics.actualBoundingBoxDescent || size * .25) <= descentLimit;
      };
      while (!fits() && size > 5) {
        size -= .5;
        context.font = `${weight} ${size}px "${family}"`;
      }
      context.fillText(text, 450, baseline);
    };
    const draw = (preview = true) => {
      const diameter = selectedSize();
      const pixels = Math.round(diameter * 300);
      if (canvas.width !== pixels) { canvas.width = pixels; canvas.height = pixels; }
      context.clearRect(0, 0, canvas.width, canvas.height);
      if (!active()) return;
      context.save();
      context.scale(pixels / 900, pixels / 900);
      context.beginPath(); context.arc(450, 450, 450, 0, Math.PI * 2); context.clip();
      context.fillStyle = '#fff'; context.fillRect(0, 0, 900, 900);
      scale = Math.max(900 / image.naturalWidth, 900 / image.naturalHeight) * Number(zoom.value) / 100;
      context.save();
      context.translate(450 + Number(x.value) * 4.5, 450 + Number(y.value) * 4.5);
      context.rotate(Number(rotation.value) * Math.PI / 180);
      context.drawImage(image, -image.naturalWidth * scale / 2, -image.naturalHeight * scale / 2, image.naturalWidth * scale, image.naturalHeight * scale);
      context.restore();
      const ribbon = editor.dataset.roundStyle === 'ribbon';
      const sports = editor.dataset.roundStyle === 'sports';
      const pet = editor.dataset.roundStyle === 'pet';
      const color = ribbonColor();
      const coloredCaption = !sports && color.selectable;
      if (ribbon) {
        context.fillStyle = ribbonColor().colors[1]; context.strokeStyle = '#fff'; context.lineWidth = 5;
        context.beginPath(); context.moveTo(225,680); context.lineTo(115,715); context.lineTo(173,742); context.lineTo(120,777); context.lineTo(245,800); context.closePath(); context.fill(); context.stroke();
        context.beginPath(); context.moveTo(675,680); context.lineTo(785,715); context.lineTo(727,742); context.lineTo(780,777); context.lineTo(655,800); context.closePath(); context.fill(); context.stroke();
        context.fillStyle = ribbonColor().colors[0];
        context.beginPath(); context.moveTo(220,690); context.quadraticCurveTo(450,720,680,690); context.lineTo(670,805); context.quadraticCurveTo(450,835,230,805); context.closePath(); context.fill(); context.stroke();
      } else if (pet) {
        context.fillStyle = coloredCaption ? color.colors[0] : '#b78694'; context.fillRect(0, 610, 900, 290);
        context.fillStyle = coloredCaption ? color.colors[2] : '#fff'; context.textAlign = 'center'; context.font = '24px sans-serif';
        ['Though you’ve departed our world', 'your paw prints endure', 'as a lasting imprint on our hearts'].forEach((line, i) => context.fillText(line, 450, 659 + i * 31));
      } else {
        const gradient = context.createLinearGradient(0, 670, 0, 900);
        const shade = coloredCaption ? color.colors[0] : '#ffffff';
        gradient.addColorStop(0, `${shade}00`); gradient.addColorStop(.22, sports && color.name === 'White' ? 'rgba(25,30,35,.30)' : `${shade}eb`); gradient.addColorStop(1, sports && color.name === 'White' ? 'rgba(25,30,35,.82)' : shade);
        context.fillStyle = gradient; context.fillRect(0, 670, 900, 230);
      }
      context.fillStyle = ribbon || coloredCaption ? color.colors[2] : sports ? color.colors[0] : pet ? '#fff' : '#15232a'; context.textAlign = 'center'; context.textBaseline = 'alphabetic';
      const lines = (caption.value || '').trim().split(/\n/).filter(Boolean).slice(0, 2);
      const secondary = (year?.value || '').trim();
      const script = font.value === 'Script';
      const family = script ? 'Beese Allura' : 'Beese Libre';
      const text = secondary ? lines.join(' ') : lines[0] || '';
      if (sports) {
        const name = [text.toUpperCase(), secondary ? '#' + secondary.replace(/^#/, '') : ''].filter(Boolean).join('  ');
        context.save(); context.translate(450, 0); context.scale(.78, 1); context.translate(-450, 0);
        fitText(name, script ? 74 : 74, script ? 'Beese Allura' : 'Arial', script ? 400 : 'italic 900', 730, 777, 85, 22);
        context.restore();
        fitText([team?.value, sport?.value].filter(Boolean).join(' · ').toUpperCase(), 27, 'Arial', 700, 510, 827, 32, 18);
      } else {
      fitText(text, script ? 64 : 48, family, script ? 400 : 700, ribbon ? 400 : 560, ribbon ? 765 : 785, ribbon ? 51 : 85, secondary || lines[1] ? 14 : ribbon ? 49 : 65);
      if (secondary) fitText(secondary, ribbon ? 26 : 32, 'Beese Libre', 400, ribbon ? 400 : 420, ribbon ? 801 : 837, ribbon ? 20 : 28, ribbon ? 13 : 32);
      else if (lines[1]) fitText(lines[1], script ? 64 : 48, family, script ? 400 : 700, ribbon ? 400 : 420, ribbon ? 801 : 837, ribbon ? 20 : 28, ribbon ? 13 : 32);
      }
      context.restore();
      const holeY = .2775 / diameter * 900;
      const holeRadius = .185 / diameter * 450;
      context.save(); context.scale(pixels / 900, pixels / 900); context.globalCompositeOperation = 'destination-out';
      context.beginPath(); context.arc(450, holeY, holeRadius, 0, Math.PI * 2); context.fill(); context.restore();
      if (preview) {
        context.save(); context.scale(pixels / 900, pixels / 900); context.strokeStyle = '#a69b8b'; context.lineWidth = 2;
        context.beginPath(); context.arc(450, holeY, holeRadius, 0, Math.PI * 2); context.stroke(); context.restore();
      }
    };
    const refresh = () => {
      revision += 1;
      clearOutput();
      const enabled = active();
      editor.hidden = !image;
      controls.hidden = !enabled;
      galleryPreview.hidden = !enabled;
      adjust.hidden = !enabled;
      gallery.classList.toggle('product-gallery--round-preview', enabled);
      form.dispatchEvent(new CustomEvent('beese:ornament-preview', { detail: { active: enabled } }));
      sizeNote.hidden = !image || eligible() || Boolean(form.querySelector('[data-reuse-artwork]')?.checked);
      font.disabled = !eligible() || Boolean(form.querySelector('[data-reuse-artwork]')?.checked);
      if (year?.hasAttribute('data-round-year')) year.disabled = !enabled;
      layout.disabled = !enabled;
      textSize.disabled = !enabled;
      textSizeProperty.disabled = !enabled;
      textSizeValue.value = `${textSize.value}%`;
      textSizeProperty.value = `${textSize.value}%`;
      if (!enabled) { lowCheck.required = false; lowCheck.disabled = true; return; }
      layout.value = `${selectedSize()} inch round; hole 0.185 inch; top edge gap 0.185 inch; ${editor.dataset.roundStyle} caption; font ${font.value}`;
      editor.querySelector('[data-round-dimensions]').textContent = settings.dimensions.replace('[size]', String(selectedSize()));
      editor.querySelector('[data-round-custom-color]').hidden = editor.dataset.roundStyle !== 'ribbon' || !ribbonColor().custom;
      draw();
      const angle = Number(rotation.value) * Math.PI / 180;
      const dx = Number(x.value) * 4.5;
      const dy = Number(y.value) * 4.5;
      const localX = dx * Math.cos(angle) + dy * Math.sin(angle);
      const localY = -dx * Math.sin(angle) + dy * Math.cos(angle);
      editor.querySelector('[data-round-edge]').hidden = image.naturalWidth * scale / 2 >= 450 + Math.abs(localX) && image.naturalHeight * scale / 2 >= 450 + Math.abs(localY);
      const dpi = Math.floor(900 / (selectedSize() * scale));
      quality.textContent = dpi >= 300 ? settings.good : dpi >= 150 ? settings.medium : settings.low;
      editor.querySelector('[data-round-dpi]').textContent = settings.dpi.replace('[dpi]', String(dpi));
      editor.querySelector('[data-round-quality-details]').open = dpi < 300;
      quality.dataset.quality = dpi >= 300 ? 'good' : dpi >= 150 ? 'medium' : 'low';
      lowWrap.hidden = dpi >= 150;
      lowCheck.required = dpi < 150;
      lowCheck.disabled = dpi >= 150;
    };
    const fonts = Promise.all([
      new FontFace('Beese Libre', `url("${settings.classic}")`, { weight: '400' }).load(),
      new FontFace('Beese Libre', `url("${settings.bold}")`, { weight: '700' }).load(),
      new FontFace('Beese Allura', `url("${settings.script}")`).load()
    ]).then(loaded => { loaded.forEach(face => document.fonts.add(face)); fontReady = true; refresh(); }).catch(() => { showError(settings.font_error); });
    input.addEventListener('change', async () => {
      const token = ++generation;
      image = null; clearOutput(); showError(''); lowCheck.checked = false; refresh();
      if (photoUrl) URL.revokeObjectURL(photoUrl);
      const file = input.files?.[0];
      if (!file || !['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) { refresh(); return; }
      photoUrl = URL.createObjectURL(file);
      const next = new Image(); next.src = photoUrl;
      try { await next.decode(); if (token !== generation) return; image = next; zoom.value = 100; x.value = 0; y.value = 0; rotation.value = 0; refresh(); await fonts; refresh(); }
      catch { if (token === generation) { editor.hidden = false; controls.hidden = true; showError(settings.image_error); } }
    });
    editor.querySelector('[data-round-remove]').addEventListener('click', () => { input.value = ''; input.dispatchEvent(new Event('change', { bubbles: true })); });
    reset.addEventListener('click', () => { zoom.value = 100; x.value = 0; y.value = 0; rotation.value = 0; lowCheck.checked = false; showError(''); refresh(); });
    adjust.querySelector('[data-round-text-reset]').addEventListener('click', () => { textSize.value = 100; showError(''); refresh(); });
    [zoom, x, y, rotation, textSize, caption, year, font, team, sport].filter(Boolean).forEach(item => item.addEventListener('input', () => { lowCheck.checked = false; showError(''); refresh(); }));
    form.addEventListener('change', refresh);
    const png300 = async blob => {
      const bytes = new Uint8Array(await blob.arrayBuffer());
      const crc = data => {
        let value = 0xffffffff;
        for (const byte of data) { value ^= byte; for (let bit = 0; bit < 8; bit++) value = (value >>> 1) ^ (value & 1 ? 0xedb88320 : 0); }
        return (value ^ 0xffffffff) >>> 0;
      };
      const chunk = new Uint8Array(21); const view = new DataView(chunk.buffer);
      view.setUint32(0, 9); chunk.set([112,72,89,115], 4); view.setUint32(8, 11811); view.setUint32(12, 11811); chunk[16] = 1; view.setUint32(17, crc(chunk.subarray(4,17)));
      const pieces = [bytes.subarray(0,8)];
      for (let offset = 8; offset < bytes.length;) {
        const length = new DataView(bytes.buffer, bytes.byteOffset + offset, 4).getUint32(0); const end = offset + length + 12;
        const type = String.fromCharCode(...bytes.subarray(offset + 4, offset + 8));
        if (type !== 'pHYs') pieces.push(bytes.subarray(offset,end));
        if (type === 'IHDR') pieces.push(chunk);
        offset = end;
      }
      return new Blob(pieces, { type: 'image/png' });
    };
    form.encodePrintPng = png300;
    const exportFile = async () => {
      await fonts;
      if (!fontReady || !active()) throw new Error(settings.error);
      if (caption.value.trim().split(/\n/).filter(line => line.trim()).length > 2) throw new Error(settings.caption_error);
      draw(false);
      const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
      draw();
      if (!blob) throw new Error(settings.error);
      return new File([await png300(blob)], `beese-${selectedSize()}in-ornament.png`, { type: 'image/png' });
    };
    form.addEventListener('submit', async event => {
      if (event.defaultPrevented || submitting || !active()) return;
      event.preventDefault();
      if (busy) return;
      busy = true; showError('');
      const start = revision;
      const submitter = event.submitter;
      try {
        if (form.exportBundleCanvas) await form.exportBundleCanvas();
        const file = await exportFile();
        if (start !== revision || !active()) throw new Error(settings.error);
        const transfer = new DataTransfer(); transfer.items.add(file); output.files = transfer.files; output.disabled = false;
        submitting = true;
        form.requestSubmit(submitter || undefined);
        submitting = false;
      } catch (problem) { submitting = false; clearOutput(); showError(problem.message || settings.error); }
      finally { busy = false; }
    });
  });
});

